class CollectionHeadersCarousel extends HTMLElement {
    constructor() {
        super();

        this.swiperPagination = this.querySelector('.swiper-collection-headers-pagination');
    
        this.swiper = new Swiper(this, {
            slidesPerView: 1.9,
            spaceBetween: 12,
            centeredSlides: false,
            pagination: {
                el: this.swiperPagination,
                enabled: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                    centeredSlides: false,
                    pagination: {
                        el: this.swiperPagination,
                        enabled: false,
                    },
                },
                1199: {
                    slidesPerView: 3.2,
                    centeredSlides: false,
                    preventClicks: true,
                    preventClicksPropagation: true,
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        enabled: false,
                    },
                },
            },
        });
    }
}

customElements.define('collection-headers-carousel', CollectionHeadersCarousel);